import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken, getRefreshToken } from '../../../app/utils/authStorage';

const authBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AUTH_SERVICE_URL,
    prepareHeaders: (headers) => {
        const token = getAccessToken();
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: authBaseQuery,
    endpoints: (builder) => ({
        loginWithTelegram: builder.mutation({
            query: (initData) => ({
                url: '/v1/login',
                method: 'POST',
                body: {
                    'init_data': initData
                },
            }),
        }),
        loginWithTelegramWidget: builder.mutation({
            query: (telegramData) => ({
                url: '/v1/telegram_auth',
                method: 'POST',
                body: telegramData,
            }),
        }),
        register: builder.mutation({
            query: (body) => ({
                url: '/v1/register',
                method: 'POST',
                body,
            }),
        }),
        loginWithCredentials: builder.mutation({
            query: (body) => ({
                url: '/v1/web/login',
                method: 'POST',
                body,
            }),
        }),
        getAuthStatus: builder.query({
            query: () => ({
                url: '/v1/me/auth-status',
                method: 'GET',
            }),
        }),
        getCaptchaConfig: builder.query({
            query: () => ({
                url: '/v1/captcha/config',
                method: 'GET',
            }),
        }),
        startDeeplink: builder.mutation({
            query: ({ ref_id } = {}) => ({
                url: '/v1/deeplink/start',
                method: 'POST',
                body: ref_id ? { ref_id } : {},
            }),
        }),
        startLinkDeeplink: builder.mutation({
            query: () => ({
                url: '/v1/deeplink/link/start',
                method: 'POST',
                body: {},
            }),
        }),
        getDeeplinkStatus: builder.query({
            query: (token) => ({
                url: `/v1/deeplink/status?token=${encodeURIComponent(token)}`,
                method: 'GET',
            }),
        }),
        refreshToken: builder.mutation({
            query: () => ({
                url: '/v1/refresh',
                method: 'POST',
                body: {
                    'refresh_token': getRefreshToken()
                }
            }),
        }),
    }),
});


export const {
    useLoginWithTelegramMutation,
    useLoginWithTelegramWidgetMutation,
    useRegisterMutation,
    useLoginWithCredentialsMutation,
    useGetAuthStatusQuery,
    useLazyGetAuthStatusQuery,
    useGetCaptchaConfigQuery,
    useStartDeeplinkMutation,
    useStartLinkDeeplinkMutation,
    useLazyGetDeeplinkStatusQuery,
    useRefreshTokenMutation,
    refreshToken,
} = authApi;
